import { useEffect } from 'react';

/**
 * Warms the browser's HTTP cache for `url` as soon as it is known, so a LATER
 * `<img src={url}>` (e.g. the Finish-step screenshot, resolved from step 1 onward but
 * only rendered on step 4) paints from cache instead of waiting out the network
 * fetch. Fire-and-forget: the `Image` is never attached to the DOM, so nothing about
 * layout or a load/error handler is needed here (the real `<img>` still gates its own
 * reveal/fallback independently).
 */
export function usePreloadImage(url: string): void {
  useEffect(() => {
    if (!url) return;
    const img = new Image();
    img.src = url;
  }, [url]);
}
